import React from 'react';
import FormItemComponent from './form-item.component';

function FormItem(props) {
    return <FormItemComponent {...props} />;
}

export default FormItem;
